import utils from 'Helpers/utils';
import constants from 'Helpers/constants';

export const eventMethods = () => {
    return {
        getPrevOdds: function (item, hdp, oddsKey, line) {
            let key = (item.custom_event_id ? item.custom_event_id : item.id) + '_' + oddsKey + '_' + hdp + '_' + line; // + '_' + item[oddsKey]

            return this.odds[key] ? this.odds[key] : false;
        },

        setPrevOdds: function (item, hdp, oddsKey, highlightClass, highlightClassIndex, line) {
            let key = (item.custom_event_id ? item.custom_event_id : item.id) + '_' + oddsKey + '_' + hdp + '_' + line;

            this.odds[key] = {
                price: item[oddsKey],
                highlightClass: highlightClass,
                highlightClassIndex: highlightClassIndex,
            };
        },

        getHighlightClass: function (item, hdp, oddsKey, line) {
            let prevOdds = this.getPrevOdds(item, hdp, oddsKey, line);

            /*need classes with indexes 1 and 2, we switch classes when prices change continuously*/
            if (prevOdds) {
                if (item[oddsKey] === prevOdds.price) {
                    return prevOdds.highlightClass;
                } else if (item[oddsKey] > prevOdds.price) {
                    let hlClassIndex = prevOdds.highlightClassIndex === 1 ? 2 : 1;
                    this.setPrevOdds(item, hdp, oddsKey, 'highlightGreen' + hlClassIndex, hlClassIndex, line);
                    return 'highlightGreen' + hlClassIndex;
                } else {
                    let hlClassIndex = prevOdds.highlightClassIndex === 1 ? 2 : 1;
                    this.setPrevOdds(item, hdp, oddsKey, 'highlightRed' + hlClassIndex, hlClassIndex, line);
                    return 'highlightRed' + hlClassIndex;
                }
            }

            this.setPrevOdds(item, hdp, oddsKey, '', 1, line);

            return '';
        },
        isExpandedToggle() {
            this.isExpanded = !this.isExpanded;
        },
        loadMorePrices() {
            this.loadMore = true;
        },
        isEmpty(value) {
            return _.isEmpty(value);
        },
        onPriceClick(price, periodId, handicapKey, oddsMaxKey, betTypeId, betSelectionId, oddsListKey, teamKey) {
            //need to convert str to array and skip price id - data[1]
            price[oddsListKey] = JSON.parse(price[oddsListKey]).map((data) => [data[0], data[2]]);

            let keys = Object.keys(this.betFeedData);
            // let feedLine = { ...this.event, ...this.eventStats, ...price };
            //max count of allowed dialogs
            if (keys.length >= 4) {
                return;
            }

            let idx = keys.length === 0 ? 0 : parseInt(_.max(keys)) + 1;
            console.log('Idx will be used for new bet dialog: %s', [idx]);

            let betFeedData = {};

            betFeedData['ceId'] = this.event.ceId;
            betFeedData['clName'] = this.event.clName;
            betFeedData['cthName'] = this.event.cthName;
            betFeedData['ctaName'] = this.event.ctaName;
            betFeedData['clId'] = this.event.clId;
            betFeedData['cthId'] = this.event.cthId;
            betFeedData['ctaId'] = this.event.ctaId;
            betFeedData['team'] = this.event[teamKey];
            betFeedData['sc'] = this.eventStats.score ?? null;
            betFeedData['correctScore'] = (betSelectionId === constants.BET_SELECTION_CS && price.score) ?? null;
            betFeedData['corners'] = utils.isValidNumber(this.eventStats.corners_home) ? (this.eventStats.corners_home + '-' + this.eventStats.corners_away) : null;
            betFeedData['time'] = this.eventStats.time ?? null;
            betFeedData['dateGame'] = this.event.dg;
            betFeedData['marketId'] = this.event.mId;
            betFeedData['periodTypeId'] = periodId;
            betFeedData['market'] = utils.extractPriceData(price, handicapKey, oddsMaxKey, betTypeId, oddsListKey);
            betFeedData['handicapKey'] = handicapKey;
            betFeedData['oddsMaxKey'] = oddsMaxKey;
            betFeedData['betTypeId'] = betTypeId;
            betFeedData['betSelectionId'] = betSelectionId;
            betFeedData['oddsListKey'] = oddsListKey;
            betFeedData['isActive'] = true;
            betFeedData['uuid'] = Date.now();

            this.betFeedData = { idx: idx, betFeedData: betFeedData };

            let ref = 'betDialog' + idx;

            this.$nextTick(() => {
                utils.updateUserData(true);

                this.$parent.$parent.$refs[ref][0].open();
            });
        },
    };
};

export const eventGetters = () => {
    return {
        pricesBest() {
            return this.loadMore ? this.prices : this.prices.slice(0, 3);
        },
        toolUserSettings: {
            get() {
                return this.$store.getters['AppModule/getToolUserSettings'];
            },
            set(value) {
                this.$store.commit('AppModule/setToolUserSettings', value);
            },
        },
    };
};
